export const goToLink = (link, target) => {
  link && (target ? window.open(link, target) : window.open(link, '_self'));
};

export const parseRegionURL = (url) => {
  //let newUrl = url.replaceAll(" ", "-");
  let newUrl = url.split(" ").join("-");
  newUrl = newUrl.toLowerCase();
  newUrl = newUrl.replace("à", "a");
  newUrl = newUrl.replace("è", "e");
  newUrl = newUrl.replace("é", "e");
  newUrl = newUrl.replace("ì", "i");
  newUrl = newUrl.replace("ò", "o");
  newUrl = newUrl.replace("ù", "u");
  return newUrl
}

export const parseRegionName = (name) => {
  let newName = name.split("-").join(" ");
  //let newName = name.replaceAll("-", " ");
  return newName;
}